import gql from "graphql-tag";

export const GetOrderCashOutReport = gql`
  query AccountEarnings (
    $origin: String!
    $createdAt: QueryableDateTime
    $vendor: PaymentVendorOptions
  ) {
    earnings(vendor: $vendor) {
      earned
      owed
      paid
    }
    payments (createdAt: $createdAt) {
      id
      paid
      amountDue
      createdAt
      updatedAt
      paymentVendor
      order {
        id
        product {
          id
          name
          sku
        }
      }
    }
    accounts {
      id
      bank {
        digits
        name
        arePayoutsEnabled
        hasUnfulfilledRequirements
        hasOverdueRequirements
        stripeRequirementLink(origin: $origin)
      }
    }
  }
`;
